import React from 'react'

import ReportTable from '../report_table'
import * as Helper from '../../../../helpers/helper'
import { ConfidenceScoreInfoIcon } from '../confidence_score_info_icon'
import { formatReportDate, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/email_finder/report_individual_table.js
const ReportTableIndividual = (props) => {

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.userReportData.breakdown)
  }

  const confidenceLevelFormatter = (cell, row) => {
    return Helper.calculateConfidenceLevelTagFromScore(row.confidence_score / row.found)
  }

  const confidenceScoreFormatter = (cell, row) => {
    let score = row.confidence_score === 0 ? '-' : row.confidence_score / row.found
    return score > 0 ? score.toFixed() : 0
  }

  const getTableData = () => {
    let tableData = []
    let tmp = props.tableData && props.tableData[0] && props.tableData[0].stats ? props.tableData[0].stats : props.tableData
    tmp.forEach((data) => {
      if (data.total > 0) {
        tableData.push(data)
      }
    })

    return tableData
  }

  const formatConfidenceScoreHeader = (column, colIndex, { sortElement }) => {
    return (
      <div>
        {column.text}
        <ConfidenceScoreInfoIcon />
        {sortElement}
      </div>
    )
  }

  const data = getTableData()
  const formatNumber = localeNumberFormatter('0')

  const columns = [
    {
      dataField: 'date',
      text: 'Day',
      formatter: dateFormatter,
      headerStyle: { width: '20%' },
      style: { width: '20%' },
    },
    {
      dataField: 'found',
      text: 'Email Found',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Found'
    },
    {
      dataField: 'not_found',
      text: 'Email Not Found',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Not Found'
    },
    {
      dataField: 'total',
      text: 'Total Request',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Found'
    },
    {
      dataField: 'confidence_score',
      text: 'Confidence Level',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: confidenceLevelFormatter,
      align: 'right'
    },
    {
      dataField: 'duplicate',
      text: 'Confidence Score',
      headerFormatter: formatConfidenceScoreHeader,
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: confidenceScoreFormatter,
      align: 'right',
      sort: true
    },
    {
      dataField: 'business',
      text: 'Business Email',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'role',
      text: 'Role Email',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
    },
    {
      dataField: 'billable',
      text: 'Billable Credits',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div className="report-table">
      <ReportTable
        keyField="date"
        data={data}
        columns={columns}
        wrapperClasses="table-report table-responsive"
        noDataIndication={noDataIndication}
      />
    </div>
  )
}

export default ReportTableIndividual
